import React from 'react';
import { Heading, Logo, Container } from '@landr/maestro';
import { css } from '@landr/styled-system/css';
import { Trans, Plural } from '@lingui/macro';
import Artworks from 'components/Artworks/Artworks';
import DescriptiveSection from '../DescriptiveSection/DescriptiveSection';
import OneCreditOneSample from '../OneCreditOneSample/OneCreditOneSample';

export const headingStyled = css({
    color: 'text.inverted',
    fontSize: '3xl',
    lineHeight: '2xl',
});

export const creditsStyled = css({
    color: 'success.500',
});

export const artworksWrapper = css({
    margin: {
        md: 0,
    },
    marginBottom: {
        base: '3xl',
        md: '2xl',
    },
    width: '100%',
});

const PremiumHeader = ({ creditsNeeded }: { creditsNeeded: number }) => (
    <Plural
        value={creditsNeeded}
        one={
            <Trans>
                Subscribe to get this sample{' '}
                <span className={creditsStyled}>without spending credits</span>
            </Trans>
        }
        other={
            <Trans>
                Subscribe to get these samples{' '}
                <span className={creditsStyled}>without spending credits</span>
            </Trans>
        }
    />
);

const CreditsHeader = ({ creditsNeeded }: { creditsNeeded: number }) => (
    <Plural
        value={creditsNeeded}
        one={
            <Trans>
                You are missing{' '}
                <span className={creditsStyled}>
                    {/* \u00A0 is a non breaking-space &nbsp; but we have to use unicode so that lingui keep the non-breaking space char */}
                    {`${creditsNeeded}\u00A0credit`}
                </span>{' '}
                to download this sample
            </Trans>
        }
        other={
            <Trans>
                You are missing{' '}
                <span className={creditsStyled}>
                    {/* \u00A0 is a non breaking-space &nbsp; but we have to use unicode so that lingui keep the non-breaking space char */}
                    {`${creditsNeeded}\u00A0credits`}
                </span>{' '}
                to download these samples
            </Trans>
        }
    />
);

export const DescriptivePaidUpsell = ({
    artUrl,
    creditsNeeded,
    isPremium,
}: {
    artUrl?: string;
    creditsNeeded: number;
    isPremium: boolean;
}) => {
    return (
        <>
            <DescriptiveSection>
                {artUrl ? (
                    <Container className={artworksWrapper} size="xs">
                        <Artworks
                            artworks={[
                                {
                                    isExclusive: false,
                                    artworkUrl: artUrl,
                                },
                            ]}
                        />
                    </Container>
                ) : (
                    <Logo variant="brand" color="text.inverted" mb="2xl" />
                )}
                <Heading className={headingStyled} as="h2">
                    {isPremium && (
                        <PremiumHeader creditsNeeded={creditsNeeded} />
                    )}
                    {!isPremium && (
                        <CreditsHeader creditsNeeded={creditsNeeded} />
                    )}
                </Heading>
                <OneCreditOneSample />
            </DescriptiveSection>
        </>
    );
};

export default DescriptivePaidUpsell;
